(function () {
  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a)); };
  var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Horizon scrolls an inner .page-wrapper rather than the document, and a scroll
  // event on an element does not bubble to window. Listening only on window means
  // never hearing about scrolling at all, so find whatever really scrolls. It
  // varies by breakpoint on this theme, so this is re-checked, not assumed.
  function scrollerOf(el) {
    var n = el.parentElement;
    while (n && n !== document.body && n !== document.documentElement) {
      var cs = getComputedStyle(n);
      if (/(auto|scroll|overlay)/.test(cs.overflowY) && n.scrollHeight > n.clientHeight + 4) return n;
      n = n.parentElement;
    }
    return null;
  }

  function Hero(root) {
    if (root.__hs) return;
    root.__hs = this;
    var q = function (s) { return root.querySelector(s); };
    this.root = root;
    this.el = {
      film: q('.hs__film'), canvas: q('.hs__canvas'), video: q('.hs__video'), glow: q('.hs__glow'),
      intro: q('.hs__intro'), rail: q('.hs__rail'), railItems: root.querySelectorAll('.hs__rail li'),
      pill: q('.hs__pill'), pillNum: q('.hs__pill .hs__num'), pillLab: q('.hs__pill .hs__lab'),
      progress: q('.hs__progress'), bar: q('.hs__progress span'),
      hint: q('.hs__hint'), outro: q('.hs__outro'), skip: q('.hs__skip')
    };
    var d = root.dataset;
    var labels = Array.prototype.map.call(this.el.railItems, function (li) { return li.querySelector('.hs__lab').textContent; });
    var c1 = (+d.c1 || 0) / 100, c2 = (+d.c2 || 36) / 100, c3 = (+d.c3 || 54) / 100;
    this.chapters = [
      { num: '01', label: labels[0], a: c1, b: c2 },
      { num: '02', label: labels[1], a: c2, b: c3 },
      { num: '03', label: labels[2], a: c3, b: 0.86 }
    ];
    this.target = this.cur = reduced ? 1 : 0;
    this.frames = []; this.set = null; this.lastKey = '';
    this.queue = []; this.inflight = 0; this.gen = 0; this.painted = false;
    this.filmSource = d.filmSource === 'video' ? 'video' : 'frames';
    this.seekSamples = []; this.seekMode = null; this.lastSeek = -1;
    this.measure = this.measure.bind(this);
    this.tick = this.tick.bind(this);
    this.scroller = scrollerOf(root);
    window.addEventListener('scroll', this.measure, { passive: true });
    if (this.scroller) this.scroller.addEventListener('scroll', this.measure, { passive: true });
    window.addEventListener('resize', this.measure);
    var self = this;
    this.io = new IntersectionObserver(function (e) {
      self.visible = e[0].isIntersecting;
      // A looping film off screen is pure battery drain.
      var v = self.el.video;
      if (v && self.seekMode === false) {
        if (self.visible) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else v.pause();
      }
      if (self.visible && !self.raf) self.raf = requestAnimationFrame(self.tick);
    });
    this.io.observe(root);
    this.measure();
    this.render(this.cur);
  }

  // Order the frames coarse-to-fine: every 8th, then every 4th, then every 2nd,
  // then the rest. draw() already falls back to the nearest loaded neighbour, so
  // the first pass alone makes the whole film scrubbable end to end - at 1/8 the
  // bytes - and each later pass quietly sharpens it. Loading 0..n-1 in order
  // instead would leave the back half of the scroll dead until the very end.
  function ladder(n, strides) {
    var seen = {}, out = [], s, i;
    var want = function (i) { if (i >= 0 && i < n && !seen[i]) { seen[i] = 1; out.push(i); } };
    want(0); want(n - 1);
    for (s = 0; s < strides.length; s++) for (i = 0; i < n; i += strides[s]) want(i);
    return out;
  }

  Hero.prototype.loadFrames = function (mobile) {
    var key = mobile ? 'm' : 'd';
    if (this.set === key) return;
    this.set = key;
    var d = this.root.dataset;
    var base = mobile ? d.mobileFrameBase : d.frameBase;
    var n = +(mobile ? d.mobileFrameCount : d.frameCount) || 0;
    this.base = base;
    this.ext = d.frameExt || '.jpg';
    this.padTo = +d.pad || 3;
    // Bumping the generation orphans any request still in flight for the old
    // set, so a resize across the breakpoint can't have stale handlers write
    // into the new array or corrupt the in-flight count.
    this.gen++;
    this.inflight = 0;
    this.frames = new Array(n);
    this.queue = [];
    this.lastKey = '';
    if (!base || !n) return;

    // On a metered or genuinely slow connection, stop at every 4th frame. The
    // scrub still works everywhere; it just steps a little coarsely instead of
    // spending megabytes the visitor is paying for.
    var conn = navigator.connection || navigator.mozConnection || {};
    var thrifty = conn.saveData === true || /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '');
    this.queue = ladder(n, thrifty ? [8, 4] : [8, 4, 2, 1]);

    var self = this, kicked = false;
    var start = function () { if (kicked) return; kicked = true; self.pump(); };
    var soon = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1); };
    // Never race the rest of the page: the poster carries the first paint, so the
    // frames can wait for a quiet moment after load. But whoever starts scrolling
    // before that needs them now, so the first scroll jumps the queue.
    if (document.readyState === 'complete') soon(start);
    else window.addEventListener('load', function () { soon(start); }, { once: true });
    (this.scroller || window).addEventListener('scroll', start, { once: true, passive: true });
  };

  Hero.prototype.pump = function () {
    var self = this, gen = this.gen;
    while (this.inflight < 6 && this.queue.length) {
      var i = this.queue.shift();
      this.inflight++;
      var img = new Image();
      img.decoding = 'async';
      img.fetchPriority = 'low';
      img.onload = img.onerror = function () {
        if (gen !== self.gen) return;
        self.inflight--;
        // Only a frame that actually decoded may reveal the canvas. Marking
        // ready on error would swap the poster out for an empty black box when
        // the frames are missing or misnamed.
        if (!self.painted && this.naturalWidth) {
          self.painted = true;
          self.root.classList.add('is-ready');
        }
        // Any arrival can improve the current position, not just frame 0.
        self.lastKey = '';
        self.draw();
        self.pump();
      };
      img.src = this.base + String(i).padStart(this.padTo, '0') + this.ext;
      this.frames[i] = img;
    }
  };

  // Video mode. The film is one mp4 instead of 120 stills, so scroll drives
  // currentTime rather than an image index. Only one seek is ever in flight at a
  // time: firing a seek per scroll event is what makes this technique stutter.
  Hero.prototype.setupVideo = function () {
    var v = this.el.video;
    if (!v) return;
    if (this.vInit) { this.applyVideoMode(); return; }
    this.vInit = true;
    var self = this;
    // Pick the rendition before the first byte is fetched, so a phone never pays
    // for the desktop file.
    var src = (this.narrow && v.getAttribute('data-src-m')) || v.getAttribute('data-src');
    if (!src) return;
    v.src = src;
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.loop = true;

    v.addEventListener('loadeddata', function () {
      self.vDur = v.duration || 0;
      self.root.classList.add('is-ready');
      self.painted = true;
      self.lastSeek = -1;
      self.applyVideoMode();
      self.scrub();
    });

    v.addEventListener('seeked', function () {
      self.pendingSeek = false;
      self.seekSamples.push(performance.now() - self.seekAt);
      // If this device can't seek fast enough to feel like scrubbing, stop
      // pretending: let the film play on its own timeline instead of showing
      // the visitor a juddering mess.
      if (self.seekSamples.length === 10 && !self.seekBanned) {
        var s = self.seekSamples.slice().sort(function (a, b) { return a - b; });
        if (s[5] > 140) { self.seekBanned = true; self.applyVideoMode(); }
      }
      if (self.visible && !self.raf) self.raf = requestAnimationFrame(self.tick);
    });

    v.addEventListener('error', function () {
      // A missing or blocked video must not leave the poster hidden behind a
      // black rectangle, same rule as a missing frame.
      self.root.classList.remove('is-ready');
      self.painted = false;
    });

    this.applyVideoMode();
  };

  Hero.prototype.applyVideoMode = function () {
    var v = this.el.video;
    if (!v) return;
    // Desktop scrubs. Phones play, because inline video seeking there is slow and
    // unreliable. Reduced-motion scrubs too, so it simply rests on the last frame.
    var wantSeek = this.seekBanned ? false : (reduced || !this.narrow);
    this.seekMode = wantSeek;
    // Reconcile playback every call rather than only on a mode change. The first
    // call happens before the video has any data, so that play() is dropped; an
    // early return on "mode unchanged" would then never retry after loadeddata
    // and a phone would sit on a frozen first frame.
    if (wantSeek) {
      if (!v.paused) v.pause();
    } else if (this.visible !== false && v.paused) {
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    }
  };

  Hero.prototype.scrub = function () {
    var v = this.el.video;
    if (!v || !this.seekMode || !this.vDur) return;
    var t = clamp(this.cur) * (this.vDur - 0.06);
    if (this.pendingSeek || Math.abs(t - this.lastSeek) < 0.02) return;
    this.lastSeek = t;
    this.pendingSeek = true;
    this.seekAt = performance.now();
    try { v.currentTime = t; } catch (e) { this.pendingSeek = false; }
  };

  Hero.prototype.draw = function () {
    var c = this.el.canvas, f = this.frames, n = f.length;
    if (!c || !n) return;
    var idx = Math.round(clamp(this.cur) * (n - 1)), img = f[idx];
    if (!img || !img.complete || !img.naturalWidth) {
      for (var k = 1; k < n; k++) {
        var a = f[idx - k], b = f[idx + k];
        if (a && a.complete && a.naturalWidth) { img = a; break; }
        if (b && b.complete && b.naturalWidth) { img = b; break; }
      }
    }
    if (!img || !img.naturalWidth) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var cw = Math.round(c.clientWidth * dpr), ch = Math.round(c.clientHeight * dpr);
    if (!cw || !ch) return;
    var key = img.src + cw + 'x' + ch;
    if (key === this.lastKey) return;
    this.lastKey = key;
    if (c.width !== cw || c.height !== ch) { c.width = cw; c.height = ch; }
    var ctx = c.getContext('2d');
    var portrait = ch > cw * 1.1;
    var s = portrait ? Math.max((ch * 0.62) / img.naturalHeight, cw / img.naturalWidth)
                     : Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
    var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    var dy = portrait ? ch * 0.56 - dh / 2 : (ch - dh) / 2;
    if (portrait) { ctx.fillStyle = '#07090A'; ctx.fillRect(0, 0, cw, ch); }
    ctx.drawImage(img, (cw - dw) / 2, dy, dw, dh);
    if (portrait) {
      var gt = ctx.createLinearGradient(0, dy, 0, dy + dh * 0.22);
      gt.addColorStop(0, '#07090A'); gt.addColorStop(1, 'rgba(7,9,10,0)');
      ctx.fillStyle = gt; ctx.fillRect(0, dy - 1, cw, dh * 0.22 + 1);
      var gb = ctx.createLinearGradient(0, dy + dh * 0.8, 0, dy + dh);
      gb.addColorStop(0, 'rgba(7,9,10,0)'); gb.addColorStop(1, '#07090A');
      ctx.fillStyle = gb; ctx.fillRect(0, dy + dh * 0.8, cw, dh * 0.2 + 1);
    }
  };

  Hero.prototype.measure = function () {
    var r = this.root.getBoundingClientRect();
    // Measure the section against whatever box actually scrolls it, so a theme
    // that scrolls an inner wrapper behaves identically to one that scrolls the
    // document. Both rects are viewport-relative, so the difference is the offset.
    var host = this.scroller
      ? this.scroller.getBoundingClientRect()
      : { top: 0, height: window.innerHeight || 800 };
    var vh = host.height || window.innerHeight || 800;
    this.narrow = r.width < 760;
    // In video mode the frame sets are never requested at all, so switching the
    // section to video costs nothing in wasted 404s.
    if (this.filmSource === 'video') this.setupVideo();
    else this.loadFrames(this.narrow);
    this.target = reduced ? 1 : clamp((host.top - r.top) / Math.max(1, r.height - vh));
    if (!this.raf && this.visible) this.raf = requestAnimationFrame(this.tick);
  };

  Hero.prototype.tick = function () {
    this.raf = 0;
    this.cur += (this.target - this.cur) * 0.12;
    if (Math.abs(this.target - this.cur) < 0.0004) this.cur = this.target;
    this.render(this.cur);
    if (this.filmSource === 'video') this.scrub(); else this.draw();
    if (this.visible && this.cur !== this.target) this.raf = requestAnimationFrame(this.tick);
  };

  Hero.prototype.render = function (p) {
    var e = this.el, n = this.narrow;
    var final = ease(seg(p, 0.86, 0.96));
    var introOut = seg(p, 0.08, 0.18);
    if (e.intro) {
      e.intro.style.opacity = 1 - introOut;
      e.intro.style.transform = n ? 'translateY(' + (-introOut * 30) + 'px)' : 'translateY(-50%) translateX(' + (-introOut * 40) + 'px)';
    }
    if (e.hint) e.hint.style.opacity = 1 - seg(p, 0.02, 0.08);
    var rail = seg(p, 0.18, 0.26) * (1 - seg(p, 0.84, 0.9));
    if (e.rail) e.rail.style.opacity = rail;
    if (e.progress) e.progress.style.opacity = rail;
    if (e.bar) e.bar.style.height = (p * 100) + '%';
    var active = -1;
    for (var i = 0; i < this.chapters.length; i++) if (p >= this.chapters[i].a && p < this.chapters[i].b) active = i;
    for (var j = 0; j < e.railItems.length; j++) e.railItems[j].classList.toggle('is-on', j === active);
    if (e.pill) {
      e.pill.style.opacity = seg(p, 0.18, 0.26) * (1 - seg(p, 0.82, 0.88));
      if (active >= 0 && this.activeShown !== active) {
        e.pillNum.textContent = this.chapters[active].num;
        e.pillLab.textContent = this.chapters[active].label;
        this.activeShown = active;
      }
    }
    if (e.film) e.film.style.transform = n
      ? 'translateY(' + (-final * 17) + '%) scale(' + (1 - final * 0.14) + ')'
      : 'translateX(' + (final * 24) + '%) scale(' + (1 - final * 0.07) + ')';
    var orb = ease(seg(p, 0.42, 0.6));
    if (e.glow) {
      e.glow.style.opacity = 0.25 + orb * 0.45 + final * 0.3;
      e.glow.style.transform = 'scale(' + (0.8 + final * 0.25) + ')';
    }
    if (e.outro) {
      e.outro.style.opacity = final;
      e.outro.style.pointerEvents = final > 0.5 ? 'auto' : 'none';
      e.outro.style.transform = n ? 'translateY(' + ((1 - final) * 30) + 'px)' : 'translateY(-50%) translateX(' + ((1 - final) * -40) + 'px)';
    }
    if (e.skip) {
      e.skip.style.opacity = 1 - final;
      e.skip.style.pointerEvents = final > 0.5 ? 'none' : 'auto';
    }
  };

  function init(scope) { (scope || document).querySelectorAll('.hs').forEach(function (el) { new Hero(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();